<svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_513_54)">
<g filter="url(#filter0_d_513_54)">
<path d="M74 38C74 20.3269 59.6731 6 42 6C24.3269 6 10 20.3269 10 38C10 55.6731 24.3269 70 42 70C59.6731 70 74 55.6731 74 38Z" fill="#C20505"/>
</g>
<path d="M54.9945 41.9988L48.8618 40.4709C48.8618 40.4709 48.0386 40.3467 48.079 39.4003L48.3229 35.985C48.3229 35.985 48.2812 35.2854 47.458 35.0378C47.458 35.0378 41.8182 32.6051 34.8866 35.171C34.8866 35.171 34.434 35.2529 34.3935 36.0759L34.7046 38.9361C34.7046 38.9361 34.9526 40.1297 33.8006 40.4579L28.0176 41.9523C28.0176 41.9523 27.609 42.2015 26.8467 41.1104C26.8467 41.1104 25.5697 39.5044 25.8976 37.9821C25.8976 37.9821 26.1618 34.2582 29.6992 32.4095C29.6992 32.4095 40.1256 26.2664 51.9407 31.9142C51.9407 31.9142 54.7811 33.11 55.8528 35.1685C55.8528 35.1685 56.8217 37.2886 56.8022 38.5848C56.8022 38.5848 57.1737 39.9431 54.9945 41.9988Z" fill="white"/>
</g>
<defs>
<filter id="filter0_d_513_54" x="0" y="0" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_513_54"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_513_54" result="shape"/>
</filter>
<clipPath id="clip0_513_54">
<rect width="84" height="84" fill="white"/>
</clipPath>
</defs>
</svg>
